/* eslint-disable react/no-array-index-key */

import React, { useEffect, forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import withValidations from 'lib/hocs/withValidations';
import { handleChange } from 'lib/stores/formStore';
import { formatIdFromName } from 'lib/utility';

import FormLabel from './FormLabel';

const FormDatePicker = ({ name, label, value, id, minDate, maxDate, required, startDate, toDate, ariaLabel }) => {
  const changeDate = newDate => {
    const date = dayjs(newDate);

    if (!date.isValid()) return;

    handleChange(toDate ? date.toDate() : date.format('YYYY-MM-DD'), name);
  };

  const DateInput = forwardRef((props, ref) => (
    <input {...props} ref={ref} data-testid={id || formatIdFromName(name)} required={required} />
  ));

  useEffect(() => {
    if (!startDate) return;
    if (value) return;

    changeDate(startDate);
  }, [startDate]);

  return (
    <div className="mb-3">
      {label && (
        <FormLabel id={id || formatIdFromName(name)} label={label} required={required} />
      )}
      <DatePicker
        name={name}
        selected={value && dayjs(value).toDate()}
        className="form-control"
        onChange={date => changeDate(date)}
        customInput={<DateInput />}
        id={id || formatIdFromName(name)}
        dateFormat="dd/MM/yyyy"
        calendarAriaLabel="date picker"
        dropdownMode="select"
        maxDate={maxDate}
        minDate={minDate}
        aria-label={ariaLabel}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
      />
    </div>
  );
};

export default withValidations({ required: true })(FormDatePicker);
